import React from "react";
import { makeStyles, Theme } from "@material-ui/core";
import { Field } from "react-final-form";
import { Checkbox } from "final-form-material-ui";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "150px 300px",
    gap: theme.spacing(2),
    textAlign: "right",
    alignItems: "center",
    "& label": {
      fontSize: "16px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    "& div": {
      marginTop: "3px",
      textAlign: "left",
    },
  },
}));

type Props = {
  field: string;
  title: string;
  required?: boolean;
  disabled?: boolean;
};

export const CheckboxField: React.FC<Props> = ({ field, title, required, disabled = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <label>{title}:</label>
      <div>
        <Field name={field} component={Checkbox} type="checkbox" fullWidth disabled={disabled} validate={required ? validate : null} />
      </div>
    </div>
  );
};

const validate = (value: any) => (value && (value || "").toString().trim() != "" ? "" : "Required");
